import IMask from 'imask'

let phoneMask: IMask.MaskedPattern<string>

export const useFormatPhoneNumber = () => {
  if (!phoneMask) phoneMask = IMask.createMask({ mask: '(000) 000-0000' })
  return (phone: string) => phoneMask.resolve(phone)
}
